var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{staticStyle:{"z-index":"9999"},attrs:{"value":_vm.loadingSpinnerState.visible}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('div',[_vm._v(_vm._s(_vm.$t(_vm.loadingSpinnerState.text)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }